import React from 'react'

const GiftContactCard = () => {
  return (
    <div className='w-full bg-white p-2 rounded-md border border-gray-100  '>
  <img src="/images/Groccery/bulk-gift-image.png" alt="" />
   <h1 className='py-2 text-md font-semibold '>Looking for a bulk gift options ?</h1>
   <button className={`border w-full text-sm font-semibold bg-sky-600 hover:bg-sky-600/90  transition-colors duration-100  text-white px-3 py-2 rounded-sm`}>Contact us</button>
    </div>
  )
}

export default GiftContactCard